import { Route } from '@/app/router'

const Shipment = () => import('./index.vue')

export default new Route('/shipments/:id', Shipment)
	.as('Dashboard:Shipment')
	.permissions(['VIEW_SHIPMENT'])
